// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CustomUpload-module__button--N_e9D {\n  padding-left: 0;\n}\n", "",{"version":3,"sources":["webpack://./src/pages/OpeningInfo/components/CustomUpload/CustomUpload.module.less"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF","sourcesContent":[".button {\n  padding-left: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": "CustomUpload-module__button--N_e9D"
};
export default ___CSS_LOADER_EXPORT___;
